import { render, staticRenderFns } from "./BasePaginate.vue?vue&type=template&id=d44b955a&scoped=true&"
import script from "./BasePaginate.vue?vue&type=script&lang=js&"
export * from "./BasePaginate.vue?vue&type=script&lang=js&"
import style0 from "./BasePaginate.vue?vue&type=style&index=0&id=d44b955a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44b955a",
  null
  
)

export default component.exports